import { Appointment, AppointmentID } from "./Appointment";
import { DealerLocationID } from "./DealerLocation";
import { KioskCommunicationEventID, KioskCommunicationID } from "./KioskCommunication";
import { LANGUAGE_CODES } from "./Language";
import { UserID } from "./User";

export type KioskID = number;

export type KioskLabelID = number;

export type KioskLabelNumber = number;

export type KioskLabelEventID = number;

export enum KIOSK_LABEL_ACTION_TYPES {
  LabelAttached = 1,
  LabelDetached = 2
}

export interface Kiosk {
  created_on: string;
  updated_on: string;
  id: KioskID;
  name: string; // Name given to this Kiosk
  front_end_version: number; // Version of the Kiosk Frontend
  active: boolean; // Allows users and customer to use this KeyLocker
  confirmation_title: string; // When a Customer has completed the CheckIn, this title will be shown to them
  confirmation_image_url: string; // When a Customer has completed the CheckIn, this image will be shown to them
  stand_by_image_url: string; // The kiosk in standby display this image
  is_custom_web_page_enabled: boolean; // If enabled, then the kiosk will show a custom web page for booking appointments when required.
  custom_web_page_display_text: string; // Text or code snippet to display the custom web page
  dealer_location_id: DealerLocationID; // DealerLocation Identifier to which this Kiosk belongs to
  vat?: number; // VAT of the DealerLocation
  include_vat?: boolean; // IncludeVAT of the DealerLocation
  language_code?: LANGUAGE_CODES; // LanguageCode of the DealerLocation
  country?: string; // Country of the DealerLocation
  is_customer_name_in_kiosk_checkin_enabled?: boolean; // Is customer name enabled in kiosk checkin
  is_customer_signature_in_kiosk_checkin_enabled?: boolean; // Is customer signature enabled in kiosk checkin
  show_parking_location_note_on_kiosk_check_in?: boolean; // If enabled, then kiosk checkin will show an option to customer to add a parking note, this note is treated as parking note on a workorder.
}

export interface KioskLabel {
  created_on: string;
  updated_on: string;
  id: KioskLabelID;
  number: KioskLabelNumber; // Number assigned to this Label
  appointment_id: AppointmentID | null; // Appointment Identifier currently attached to the Label
  kiosk_communication_id: KioskCommunicationID | null; // Kiosk Communication Identifier currently attached to the Label
  kiosk_id: KioskID; // Kiosk Identifier to which the Label belongs
  appointment?: Appointment; // Optionally embedded Appointment to which the label is attached
}

export interface KioskLabelEvent {
  created_on: string;
  id: KioskLabelEventID;
  kiosk_label_id: KioskLabelID; // Kiosk Label Identifier that this event is for
  kiosk_label_action_id: KIOSK_LABEL_ACTION_TYPES; // What action occurred for this event
  user_id: UserID | null; // User Identifier that triggered this event
  appointment_id: AppointmentID; // Appointment Identifier that triggered this event
  kiosk_communication_event_id: KioskCommunicationEventID | null; // Kiosk Communication Event Identifier that triggered this event
}
